export const NAMESPACE = 'BASE_ANALYSIS/';

export const SET_DATASOURCE_TYPE = NAMESPACE + 'SET_DATASOURCE_TYPE';
export const SET_DATASOURCE_URL = NAMESPACE + 'SET_DATASOURCE_URL';
export const SET_DATASOURCE_FILE = NAMESPACE + 'SET_DATASOURCE_FILE';
export const SET_HAS_RESULT = NAMESPACE + 'SET_HAS_RESULT';
